export const START_NODE_TYPES = [
  'basicAnswer',
  'conditions',
  'queryApi',
  'transferAgent',
  'assistantAI',
  'template',
];

export const canBeStartNode = (node) =>
  Boolean(node?.data?.saved) && START_NODE_TYPES.includes(node?.type);
